import { create } from 'zustand';
import type { ActiveCall } from '@itsappy/shared';

interface CallState {
  incoming: ActiveCall | null;
  ring: (call: ActiveCall) => void;
  clear: () => void;
  ended: (callId: string) => void;
}

export const useCall = create<CallState>((set) => ({
  incoming: null,
  ring: (call) => set({ incoming: call }),
  clear: () => set({ incoming: null }),
  ended: (callId) =>
    set((state) => ({ incoming: state.incoming?.id === callId ? null : state.incoming })),
}));
